import { ReactComponent as Close16Icon } from 'assets/image/svg/close16.svg';
import { Dispatch, SetStateAction, useId } from 'react';
import SelectField, { SelectOption } from 'src/components/admin/form/selectField';
import SiteFilterSelect from 'src/components/admin/site/SiteFilterSelect';
import { applySiteFilter } from 'src/utils/siteFilter.util';
import SlideUpModal from 'src/components/SlideUpModal';
import { queryFilter } from 'src/utils/proptypes';

type FilterModalProps = {
   isOpen: boolean;
   setIsOpen: Dispatch<SetStateAction<boolean>>;
   filters: queryFilter & {
      status?: string;
      errorType?: string;
      organizationId?: string;
   };
   setFilters: Dispatch<
      SetStateAction<
         queryFilter & {
            status?: string;
            errorType?: string;
            organizationId?: string;
         }
      >
   >;
   errorOptions: SelectOption[];
   statusOptions: SelectOption[];
   isFetching: boolean;
};

const FilterModal = ({ isOpen, setIsOpen, filters, setFilters, errorOptions, statusOptions, isFetching }: FilterModalProps) => {
   const titleId = useId();
   return (
      <SlideUpModal {...{ isOpen, setIsOpen }} titleId={titleId} drag className="m-2.5 w-[calc(100%-20px)]">
         <div className="flex flex-col gap-3.75 p-3.75 max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between pb-3">
               <div id={titleId} className="text-l-xl font-bold">Filter</div>
               <button onClick={() => setIsOpen(false)} className="text-gray-500 hover:text-gray-700 font-bold">
                  <Close16Icon className="text-black w-4 h-4" />
               </button>
            </div>

            {/* Dropdowns */}
            <div className="space-y-3">
               <div className="w-full flex">
                  <SelectField
                     disabled={isFetching}
                     clearable
                     options={errorOptions}
                     placeholder="Error Type"
                     searchable={false}
                     theme={{ border: 'border-border', input: 'min-h-8 min-w-[200px]', container: 'w-full' }}
                     onChange={(value: SelectOption | SelectOption[]) => {
                        if (!value) {
                           setFilters(preValues => {
                              return {
                                 ...preValues,
                                 page: 0,
                                 errorType: undefined,
                              };
                           });
                        } else {
                           setFilters(preValues => {
                              return {
                                 ...preValues,
                                 page: 0,
                                 errorType: (value as SelectOption).value,
                              };
                           });
                        }
                     }}
                     value={filters?.errorType}
                  />
               </div>

               <div className="w-full flex">
                  <SelectField
                     disabled={isFetching}
                     clearable
                     options={statusOptions}
                     placeholder="Status"
                     searchable={false}
                     theme={{ border: 'border-border', input: 'min-h-8 min-w-[200px]', container: 'w-full' }}
                     onChange={(value: SelectOption | SelectOption[]) => {
                        if (!value) {
                           setFilters(preValues => {
                              return {
                                 ...preValues,
                                 page: 0,
                                 status: undefined,
                              };
                           });
                        } else {
                           setFilters(preValues => {
                              return {
                                 ...preValues,
                                 page: 0,
                                 status: (value as SelectOption).value,
                              };
                           });
                        }
                     }}
                     value={filters?.status}
                  />
               </div>
            </div>

            {/* Site filter — every site unless one is picked (NPT-2096) */}
            <SiteFilterSelect
               className="w-full flex"
               value={filters.filterSiteId}
               onChange={filterSiteId => setFilters(prev => applySiteFilter(prev, filterSiteId))}
            />
         </div>
      </SlideUpModal>
   );
};

export default FilterModal;
